import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatApi, useApiClient } from "../../api";
import { QUERY_KEYS } from "../../constants";
import { toast } from "react-toastify";

export const useCreateChat = () => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      return await chatApi.createChat(apiClient);
    },
    onSuccess: () => {
      // Refetch chat history to get the updated list
      queryClient.invalidateQueries({
        queryKey: [...QUERY_KEYS.chatHistory(), apiClient],
      });
    },
    onError: (error) => {
      console.error("Failed to create chat:", error);
      toast.error("Something went wrong, please try again");
    },
  });
};
